import { render, staticRenderFns } from "./historyStatus.vue?vue&type=template&id=452b8123&scoped=true&"
import script from "./historyStatus.vue?vue&type=script&lang=js&"
export * from "./historyStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b8123",
  null
  
)

export default component.exports